import { render, staticRenderFns } from "./AllergenPropagationTree.vue?vue&type=template&id=8302758c&scoped=true"
import script from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
export * from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
import style0 from "./AllergenPropagationTree.vue?vue&type=style&index=0&id=8302758c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8302758c",
  null
  
)

export default component.exports